const sessionKey = 'report_machineranking_wizard'

export interface WizardData {
  from: Date
  to: Date
}

export const cleanWizardData = (): WizardData => {
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  yesterday.setHours(0, 0, 0, 0)

  const endOfYesterday = new Date(yesterday);
  endOfYesterday.setHours(23, 59, 0, 0);

  const empty: WizardData = {
    from: yesterday,
    to: endOfYesterday,
  };
  
  return empty
}
